import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SignedIn } from '@clerk/clerk-react';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import {
  PageLayout,
  ProtectedRoute,
  LoginPage,
  RegisterPage,
  ReportViewer
} from './components';
import HomePage from './pages/HomePage';
import { ThankYouPage } from './pages/ThankYouPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminReportView } from './pages/admin/AdminReportView';
import { RequireRole } from './components/auth/RequireRole';
import './styles/globals.css';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <PageLayout>
            <Routes>
              {/* ... todas tus rutas igual ... */}
              {/* Public Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              
              {/* Protected Client Routes */}
              <Route
                path="/thank-you" 
                element={
                  <SignedIn>
                    <ThankYouPage />
                  </SignedIn>
                } 
              />
              {/* Reports route - Admin only */}
              <Route 
                path="/reports/:reportId" 
                element={
                  <SignedIn>
                    <RequireRole allowedRoles={['admin']} fallback="/thank-you">
                      <ReportViewer />
                    </RequireRole>
                  </SignedIn>
                } 
              />
              
              {/* Protected Admin Routes */}
              <Route 
                path="/admin" 
                element={
                  <SignedIn>
                    <RequireRole allowedRoles={['admin']} fallback="/">
                      <AdminDashboard />
                    </RequireRole>
                  </SignedIn>
                } 
              />
              <Route 
                path="/admin/reports/:assessmentId" 
                element={
                  <SignedIn>
                    <RequireRole allowedRoles={['admin']} fallback="/">
                      <AdminReportView />
                    </RequireRole>
                  </SignedIn>
                } 
              />
              
              {/* Home Route */}
              <Route 
                path="/" 
                element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </PageLayout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;